import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ApiStatus from '../common/ApiStatus';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="footer bg-dark text-light pt-5 pb-3">
      <div className="container">
        <div className="row g-4">
          { }
          <div className="col-lg-3 col-md-6">
            <h5 className="text-light mb-3">{t('footer.about.title')}</h5>
            <p className="text-white-50 small">{t('footer.about.description')}</p>
            <div className="social-icons mt-3">
              <a href="https://web.facebook.com/people/Dr-Hasan-Haji-Medical-Center/100037144988616" target="_blank" rel="noopener noreferrer" className="me-3 text-light hover-primary">
                <i className="fab fa-facebook-f"></i>
              </a>

              <a href="https://instagram.com/drhasanhaji" target="_blank" rel="noopener noreferrer" className="me-3 text-light hover-primary">
                <i className="fab fa-instagram"></i>
              </a>
            </div>
          </div>

          { }
          <div className="col-lg-3 col-md-6">
            <h5 className="text-light mb-3">{t('footer.quickLinks.title')}</h5>
            <ul className="list-unstyled">
              <li className="mb-2">
                <Link to="/" className="text-white-50 text-decoration-none hover-white transition-all">
                  <i className="fas fa-angle-right me-2 small"></i>{t('footer.quickLinks.home')}
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/#services" className="text-white-50 text-decoration-none hover-white transition-all">
                  <i className="fas fa-angle-right me-2 small"></i>{t('footer.quickLinks.services')}
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/#about" className="text-white-50 text-decoration-none hover-white transition-all">
                  <i className="fas fa-angle-right me-2 small"></i>{t('footer.quickLinks.about')}
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/analyses" className="text-white-50 text-decoration-none hover-white transition-all">
                  <i className="fas fa-angle-right me-2 small"></i>{t('footer.quickLinks.myAnalyses')}
                </Link>
              </li>
            </ul>
          </div>

          { }
          <div className="col-lg-3 col-md-6">
            <h5 className="text-light mb-3">{t('home.contact.contactInfo')}</h5>
            <ul className="list-unstyled text-white-50 small">
              <li className="mb-3 d-flex">
                <i className="fas fa-map-marker-alt mt-1 me-3 text-primary"></i>
                <span>{t('home.contact.location')}</span>
              </li>
              <li className="mb-3 d-flex">
                <i className="fas fa-phone mt-1 me-3 text-primary"></i>
                <span dir="ltr">{t('home.contact.phone')}</span>
              </li>
              <li className="mb-3 d-flex">
                <i className="fas fa-envelope mt-1 me-3 text-primary"></i>
                <span>{t('home.contact.email')}</span>
              </li>
              <li className="mb-3 d-flex">
                <i className="fas fa-clock mt-1 me-3 text-primary"></i>
                <span>{t('home.contact.available247')}</span>
              </li>
            </ul>
          </div>

          { }
          <div className="col-lg-3 col-md-6">
            <h5 className="text-light mb-3">{t('home.contact.mapLabel')}</h5>
            <div className="map-container rounded overflow-hidden shadow-sm" style={{ height: '200px' }}>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3638.2655034852883!2d50.61469541504632!3d26.264392879256633!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e49a6158c776dfb%3A0xe265e7a5203fc1b8!2z2YXYsdmD2LIg2KfZhNiv2YPYqtmI2LEg2K3Ys9mGINit2KfYrNmK!5e0!3m2!1sen!2sbh!4v1700000000000!5m2!1sen!2sbh"                     
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title={t('home.contact.mapLabel')}
              ></iframe>
            </div>
          </div>
        </div>

        <div className="row mt-4 pt-3 border-top border-secondary">
          <div className="col-md-6 text-center text-md-start mb-2 mb-md-0">
            <p className="mb-0 text-white-50 small">
              &copy; {new Date().getFullYear()} {t('footer.copyright')}
            </p>
          </div>
          <div className="col-md-6 text-center text-md-end">
            <ApiStatus />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
